import * as React from 'react';
import axios, { CancelTokenSource, CancelTokenStatic } from 'axios';
import clsx from 'clsx';
import { Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { PaymentMethodsAccepted } from '../../models/payment/PaymentMethodsAccepted';
import { ElementDimensions } from '../../styles/ElementDimensions';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import { String_CaptchaError, String_Check_CheckPaid, String_PayCheck_ErrorCreditCard, String_PayCheck_ErrorPaymentFailed, String_PayCheck_PaymentExceedsAmountDue, String_System_ConnectionError, String_System_GeneralError } from '../../utilities/StringHelper';
import { CheckState, CheckStateContext } from '../../providers/CheckStateContextProvider';
import { NavigateCheckOutStart } from '../common/NavigateCheckOutStart';
import GooglePayButton from '@google-pay/button-react';
import "../../styles/applePay.css";
import $ from 'jquery';
import { Skin } from '../../models/common/Skin';
import themePrimary from '../../styles/themePrimary';
import ThreeDS, { ThreeDSProps } from './ThreeDS';
import { useHistory } from 'react-router';
import { ErrorCode } from '../../models/common/ErrorCode';
import { ApplePaySessionRequest } from '../../models/payment/ApplePaySessionRequest';
import { ApplePaySessionResponse } from '../../models/payment/ApplePaySessionResponse';
import { PaymentDetail } from '../../models/payment/PaymentDetail';
import { MakePaymentRequest } from '../../models/payment/MakePaymentRequest';
import { PaymentDigitalWalletType } from '../../models/payment/PaymentDigitalWalletType';
import { MakePaymentResponse } from '../../models/payment/MakePaymentResponse';
import { SplitType } from '../../models/common/SplitType';
import { CreatePaymentRequest } from '../../models/payment/CreatePaymentRequest';
import { CreatePaymentResponse } from '../../models/payment/CreatePaymentResponse';
import Loader from '../common/Loader';
import { ValidateCaptchaRequest } from '../../models/payment/ValidateCaptchaRequest';
import { ValidateCaptchaResponse } from '../../models/payment/ValidateCaptchaResponse';

const useStyles = makeStyles({
    creditButton: {
        backgroundColor: '#000000 !important',
        color: themePrimary.palette.primary.contrastText,    
        boxShadow: 'none',
        fontSize: '1.5em',
        width: '300px',
        height: '46px',
        lineHeight: '46px',
        borderRadius: '5px',
        marginTop: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'LeagueSpartan-Regular !important',
        fontWeight: 'bold',
    },
    googlePayButton: {
        width: '300px',
        height: '46px',
        marginTop: '20px !important',
        marginBottom: '0px !important',
    },
    iframe: {
        width: '100vw',
        height: '100%',
        borderWidth: '0',
    },
    iframeLandscape: {
        width: 'calc(100vw * .7)',
        height: '100%',
        borderWidth: '0',
        display: 'none',
    },
    root: {
        textAlign: 'center',
        height: 'calc(100vh - ' + (ElementDimensions.appBarHeight + ElementDimensions.stepperHeight + ElementDimensions.footerBarHeightPaymentScreen) + 'px)',
    },
    rootLandscape: {
        textAlign: 'center',
        height: '150%',
    },
    captcha: {
        textAlign: 'center',
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: (ElementDimensions.footerBarHeightPaymentScreen) + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: '100%',
    }
});

export type FreedomPayCreatePaymentCompleteHandler = (isError: boolean, errorCode?: ErrorCode, errorResponse?: string) => any;

export interface FreedomPayPaymentProps {
    total: number,
    paymentMethodAllowed: PaymentMethodsAccepted | undefined,
    createPaymentCompleteHandler: FreedomPayCreatePaymentCompleteHandler
}

export default function FreedomPayPayment(props: FreedomPayPaymentProps) {
    const { total, paymentMethodAllowed, createPaymentCompleteHandler } = props;
    const isPortrait = true;
    let history = useHistory();
    const [captchaReady, setCaptchaReady] = React.useState<boolean>(false);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });
    
    const validateCaptcha = (cancelTokenSource: CancelTokenSource, token: string) => {
        const validateCaptchaRequest: ValidateCaptchaRequest = {
            user_id: userState.state.userId!!,
            token:token
        }

        axios.post(process.env.REACT_APP_CHECKOUT_API_URL + '/payment/captcha/', validateCaptchaRequest, { cancelToken: cancelTokenSource.token })
        .then(function(response) {

            let r = response.data as ValidateCaptchaResponse;

            if (r.success === true) {
                const cancelToken = axios.CancelToken;
                const source = cancelToken.source();
        
                createPayment(source);
            }
            else {
                createPaymentCompleteHandler(true, r.error_code, String_CaptchaError.find(s => s.key === userState.state.locale)!!.value)
            }
        })
        .catch(function(error) {
            if (error.response) {
                createPaymentCompleteHandler(true, undefined, String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value)
            }
            else {
                createPaymentCompleteHandler(true, undefined, String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value)
            }
        });
    };
         

    const handleCaptchaLoaded = () => {
        //@ts-ignore
        window.grecaptcha.ready(_ => {
            //@ts-ignore
          window.grecaptcha
            .execute("6LeKanYpAAAAAOPhfVuNd9xpLMB1QXS-wcyeOZDu")
            //@ts-ignore
            .then(token => {
                const cancelToken = axios.CancelToken;
                const source = cancelToken.source();
                validateCaptcha(source, token);
            })
        })
      }

    React.useEffect(() => {
        if (!captchaReady) {
            const LoadExternalScript = () => {
                const externalScript = document.createElement("script");
                externalScript.onerror =  () => {"alert('failed')"};
                externalScript.id = "external";
                externalScript.async = true;
                externalScript.type = "text/javascript";
                externalScript.addEventListener("load", handleCaptchaLoaded)
                document.body.appendChild(externalScript);
                externalScript.src = `https://www.google.com/recaptcha/api.js?render=6LeKanYpAAAAAOPhfVuNd9xpLMB1QXS-wcyeOZDu`;
            }

            LoadExternalScript()
        }
    }, []);

    const createPayment = (cancelTokenSource: CancelTokenSource) => {
        const request: CreatePaymentRequest = {
            user_id: userState.state.userId!!,
            table_id: checkOutState.state.tableId,
            check_please_payment_id: checkState.state.paymentId!!,
            total: total,
            tax: checkState.state.checkTotal!!.tax
        }
        
        let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + checkState.state.checkSummary!!.id + "/payment/create"

        const headers = {
            'X-API-Key': checkOutState.state.restaurantApiKey,
            'location_id': checkOutState.state.restaurantId
        }

        axios.post(url, request, { headers, cancelToken: cancelTokenSource.token })
        .then(function(response) {

            let r = response.data as CreatePaymentResponse;

            if (r.success === true) {
                createPaymentCompleteHandler(false, undefined, undefined)
                window.location.replace(r.checkout_url + "&return=" + process.env.REACT_APP_BASE_URL + "/payment/freedompaycomplete")
            }
            else {
                createPaymentCompleteHandler(true, r.error_code, String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value)
            }
        })
        .catch(function(error) {
            if (error.response) {
                createPaymentCompleteHandler(true, undefined, String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value)
            }
            else {
                createPaymentCompleteHandler(true, undefined, String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value)
            }
        });
    };
    
    return (
        <div>             
            <Loader />
            <div className={classes.captcha}>
                <Typography>
                    This site is protected by reCAPTCHA and the 
                </Typography>
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms"> Terms of Service</a> apply.  
            </div>
                 
        </div>        
    );
}